import { render, staticRenderFns } from "./WorkplaceSelect.vue?vue&type=template&id=4bb82c75"
import script from "./WorkplaceSelect.vue?vue&type=script&lang=ts"
export * from "./WorkplaceSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports